export default __webpack_public_path__ + "static/media/Bed.5dff1175.svg";